import { camelize, decamelize } from 'shared/lib';

export const transformResponse = [
  (data: any, headers?: Record<string, string>) => {
    if (!data) return null;

    const contentType = headers?.['content-type']?.toLowerCase() || '';

    if (contentType.startsWith('text/csv')) {
      return data;
    }

    if (contentType.startsWith('text/html')) {
      console.warn('Received HTML instead of JSON:', data);
      return null;
    }

    return camelize(JSON.parse(data));
  },
];

/**
 * Serializes query params with decamelized keys.
 */
export const paramsSerializer = (params: Record<string, any>) => {
  return new URLSearchParams(decamelize(params)).toString();
};
